import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "./Career.css"; // Optional: For adding styles
import logo from "../../../Assets/image/logo.png";
import Dash from "../../../Assets/image/sea dash.webp";
import Ic from "../../../Assets/image/1.png";
import ARM from "../../../Assets/image/icon/arm_icon.png";
import Pro from "../../../Assets/image/SEA PROo.webp";
import Analytics from "../../../Assets/image/PngItem_2471474.webp";
// import Analytics from "../../../Assets/image/analytics.png";
import Careers from "../../../Assets/image/Untitled-1.webp";
import Bar1 from "../../../components/navigationbar/navigationbar1";
import { ReactComponent as Linux } from "../../../Assets/svg/linux-svgrepo-com.svg";
import { ReactComponent as Nvidia } from "../../../Assets/svg/nvidia-logo-svgrepo-com.svg";
import Footer from "../footer/footer";
import RevealFX from "../../../components/Effect/RevealFX";
import RevealBlurFX from "../../../components/Effect/RevealBlurFX";
import Quizz from "../../../components/Effect/quizz";
import { Link, useNavigate } from "react-router-dom";
import { Modal, ModalBody } from "reactstrap";
import { Helmet } from "react-helmet";



const CareerJoin = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const navigate = useNavigate();

  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY > lastScrollY) {
      // Scrolling down
      setIsVisible(false);
    } else {
      // Scrolling up
      setIsVisible(true);
    }

    setLastScrollY(currentScrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  const addform = () => {
    navigate('/Application_Form');
  }

  return (
    <>

      <Helmet>
        <title>Careers at SEA | Join the Future of Solar & Automation | Pune</title>
        <meta name="description" content="Build your career in power electronics  and IoT. Explore job openings for Embedded Engineers, Power electronics  Designers, and Automation Specialists at Sandip electronics ." />
        <meta name="keywords" content="electronics  engineering jobs Pune(India), embedded systems careers, solar pump controller R&D jobs, automation technician openings, SEA careers" />
        <meta property="og:title" content="Empower Your Future with Sandip electronics  and Automation" />
        <meta property="og:description" content="Join a team that's solving real-world energy challenges. Work on cutting-edge solar technology and industrial IoT solutions." />
        <meta property="og:image" content="https://seaiot.in/images/team-collaboration.jpg" />
        <meta property="og:url" content="https://seaiot.in/career" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div>
        <div className="container1">
          <div className="headingtext">
            <div className="careers1">
              <img src={Careers} alt="Aboutus" title="Aboutus" style={{ width: '320px', }} />
            </div>
            <div className="careers2">
              <h1 className="careers2h1">
                Join
              </h1>
              <h5>
                With us
              </h5>
            </div>
            <div className="careers3">
              <h5>our Team</h5>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <div className="seconddivf">
              <div className="seconddivf1">
                <h2 >
                  <u> Careers at SEA</u>
                </h2>
              </div>
              <h5 className="seconddivf2">
                Empower Your Future with Innovation and Sustainability
              </h5>
              <p className="seconddivfp">
                At SEA, we believe in driving change through technology and empowering individuals to grow with us.<br />
                As pioneers in power electronics , embedded systems, and IoT,<br />
                we’re shaping a sustainable future while creating opportunities for talented professionals like you.
              </p>
            </div>
          </div>

          <div className="imgcontent">

            <div className="thirddiv">
              <RevealBlurFX>
                <h1 className="thoughth1">
                  Explore Career Opportunities
                </h1>
                <p className="thought">
                  Join us to innovate, solve real-world problems, and make a meaningful impact.
                  We’re currently looking for passionate individuals in the  following fields:
                </p>
              </RevealBlurFX>
            </div>

            <div class="grid grid-cols-12 " style={{ backgroundColor: 'white' }}>
              <div class="col-span-12 sm:col-span-12 md:col-span-4 lg:col-span-4">
                <img src={Dash} className="circuit" alt="circuit" style={{ width: '450px', height: '100%' }} />
              </div>
              <div className="thirddiv col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-6">
                <h1 className="thirddiv1"
                >
                  🔌 Embedded Software Development
                </h1>
                <RevealBlurFX>
                  <p className="thirddiv2 ml-2 p-2" >
                    Design and develop firmware and software for microcontrollers and embedded platforms.
                    Work on real-time systems, IoT devices, and automation solutions.
                    <p className="p-1 mt-2"><b className="thirddiv2skill"> Skills:</b></p> C/C++, Python, ARM, RTOS, communication protocols (UART, SPI, I2C).
                  </p>
                </RevealBlurFX>
              </div>
            </div>

            <div class="grid grid-cols-12 p-2  Embeddedgrid">
              <RevealBlurFX>
                <div className="thirddiv col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-6">
                  <h1 className="thirddiv11"
                  >
                    <Linux />
                    <img src={ARM} alt="Logo" className="" style={{ height: '65px', width: '65px' }} />
                    <Nvidia />
                    <br />
                  </h1>
                  <h1 className="thirddiv1 mt-2">
                    Embedded Linux Development
                  </h1>
                  <p className="thirddiv2">
                    Develop Linux-based embedded applications for industrial and consumer products.
                    Configure and optimize Linux kernels and device drivers.<br />
                    <p className="mt-2"><b className="thirddiv2skill"> Skills:</b></p> Linux Kernel, Yocto, Buildroot, Shell scripting, and cross-compilation.
                  </p>
                </div>
              </RevealBlurFX>

              <div class="col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-6" style={{ justifyContent: 'flex-end' }}>
                <Quizz index={1} side={"right"}>
                  <img src={Ic} className="circuit" alt="circuit" style={{ width: '600px', height: '100%' }} />
                </Quizz>
              </div>

            </div>


            <div class="grid grid-cols-12 p-2  Powergridr">
              <div class="col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-4">
                <Quizz index={1} side={"left"}>
                  <img src={Pro} className="circuit" alt="circuit" style={{ width: '420px', height: '100%' }} />
                </Quizz>
              </div>
              <div className="thirddiv col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-8">
                <RevealBlurFX>
                  <div>
                    <h1 className="thirddiv1"
                    >
                      ⚙️ Power electronics  Engineering
                    </h1>
                    <p className="thirddiv2">
                      Design and test power electronics  circuits (VFDs, inverters, ATS).
                      Develop and optimize energy-efficient hardware solutions for solar and automation.
                      <p className="mt-2"><b className="thirddiv2skill"> Skills:</b></p> PCB design, simulation tools (OrCAD, Proteus), power electronics  principles.
                    </p>
                  </div>
                </RevealBlurFX>
              </div>
            </div>



            <div class="grid grid-cols-12 p-2 Analyticsgrid mt-5">

              <div className="thirddivgrid col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-6">
                <h1 className="thirddiv1"
                >
                  📊 AI/ML
                </h1>
                <p className="thirddiv2">
                  🤖 Artificial Intelligence / Machine Learning
                  Design and develop basic intelligent models to analyze data, recognize patterns, and support automation and decision-making. Work with structured datasets to build, test, and improve machine learning solutions for real-world applications.
                  <p className="mt-2"><b className="thirddiv1skill"> Skills:</b></p>Python, Machine Learning fundamentals, Scikit-learn, NumPy, Pandas, SQL , Data preprocessing, Model evaluation, Git/GitHub.
                </p>
              </div>
              <div class="col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-6" style={{ margin: '-23% 1px 1px 1px' }}>
                <img src={Analytics} className="circuitdata" alt="circuit" style={{ width: '450px', height: '100%' }} />
              </div>
            </div>
          </div>

          <div className="mt-10" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <div className="forthdivws">
              <h1 className="thirddivwsh1">
                Why Join Us?
              </h1>
              <p className="thirddivws2">

                Innovative Projects: Work on cutting-edge technologies in power electronics , embedded systems, and IoT.<br />
                Impactful Work: Contribute to solving rural challenges like water management and energy optimization.<br />
                Growth Opportunities: Expand your skillset with access to training, mentoring, and industry-leading projects.<br />
                Collaborative Environment: Be part of a dynamic team passionate about technology and sustainability.<br />
                Internships & Training Programs<br />    </p>
            </div>
          </div>

          <div className="companytraining">
            <div className="phbackground">
              <p>
                <p className="ph">Company Culture:</p>
                We are committed to fostering an inclusive, innovative, and supportive work environment.
                Employee well-being is our priority, offering health insurance, safety measures, and mandatory helmet use at the office, with helmets provided to employees.
                We also organize wellness programs such as yoga, meditation, and other activities to promote good health, caring for our team like a family.
              </p>
            </div>
            <p>
              <p className="ph">Internships and Training:</p>
              Our internship programs focus on embedded systems, electronics , and renewable energy technologies.
              Each intern is assigned a mentor to guide them, providing hands-on knowledge and skill development.
              We also conduct seminars and webinars to enhance learning and career growth.
            </p>
          </div>

          <div className="forthdivw">
            <p className="thirddivw2">
              We also offer internships and training for students and fresh graduates in:
              <h1 className="thirddivwh1">
                Embedded Systems and IoT<br />
                Software development<br />
                Data Analytics and Machine Learning<br />
                electronics  Hardware Design<br />

              </h1>
              <h2 className="kycb">Kickstart your career by learning from the experts at SEA!</h2>

              <div>
                <button className="applynowbtn mt-3 mb-3" onClick={addform}>
                  Apply Now
                </button>
              </div>


              <p className="thirddivw2">
                If you’re ready to take the next step in your career, we’d love to hear from you.
              </p>
              <h1 className="thirddivwh1">
                📩 Send your resume to: Akshay
              </h1>
              <h1 className="thirddivwh1">
                🖱️ Apply online at: [https://seaiot.in/career]
              </h1>

            </p>
          </div>
        </div>
      </div>
      {/* <ApplyNowModal isOpen={isOpen} onOpenChange={onOpenChange} /> */}
    </>
  );
};

export default CareerJoin;

